export const FroalaDefault = {
  text: "Dear [person-name],<p><br></p><p><br></p>Thanks,",
};
